import {
  getAcademicYears,
  getMonths,
  getSpecialists,
  getActivities,
  searchConsulting,
  getProviders,
  getFinalizedBillingStatus,
} from '../api.js';
import { getCenters as _getCenters } from '@/modules/shared/location.api';
import actionTypes from './types/action.types';
import mutationTypes from './types/mutation.types';
import { getList as getServiceLocations } from '@/modules/shared/servicelocation.api';

const actions = {
  async [actionTypes.GET_ACADEMIC_YEAR]({ commit }) {
    const { data } = await getAcademicYears();
    commit(mutationTypes.SET_ACADEMIC_YEAR, data);
  },
  async [actionTypes.GET_MONTH]({ commit }, { academicYearId }) {
    const { data } = await getMonths(academicYearId);
    commit(mutationTypes.SET_MONTH, data);
  },
  async [actionTypes.GET_SERVICE_LOCATIONS]({ commit }, { companyId }) {
    const { data } = await getServiceLocations(companyId);
    commit(mutationTypes.SET_SERVICE_LOCATION, data);
  },
  async [actionTypes.GET_SPECIALIST](
    { commit },
    { academicYearId, companyId, serviceLocationId }
  ) {
    const { data } = await getSpecialists(
      academicYearId,
      companyId,
      serviceLocationId
    );
    commit(mutationTypes.SET_SPECIALIST, data);
  },
  async [actionTypes.GET_ACTIVITY]({ commit }) {
    const { data } = await getActivities();
    commit(mutationTypes.SET_ACTIVITY, data);
  },
  async [actionTypes.GET_CENTER]({ commit }, academicYearId) {
    const { data } = await _getCenters({ academicYearId });
    commit(mutationTypes.SET_CENTER, data);
  },
  async [actionTypes.GET_PROVIDER]({ commit }, academicYearId) {
    const { data } = await getProviders(academicYearId);
    commit(mutationTypes.SET_PROVIDER, data);
  },
  async [actionTypes.GET_SEARCH_CONSULTING](
    { commit },
    {
      academicYearId,
      companyId,
      serviceLocationId,
      monthNumber,
      activityId,
      centerId,
      specialistId,
      currentPage,
      pageSize,
    }
  ) {
    const { data } = await searchConsulting(
      academicYearId,
      companyId,
      monthNumber,
      specialistId,
      activityId,
      centerId,
      serviceLocationId,
      currentPage,
      pageSize
    );
    commit(mutationTypes.SET_SEARCH_CONSULTING, data);
  },
  async [actionTypes.GET_FINALIZED_BILLING_STATUS](
    { commit },
    { academicYearId, companyId, monthNumber, specialistId, centerId }
  ) {
    const { data } = await getFinalizedBillingStatus(
      academicYearId,
      companyId,
      monthNumber,
      specialistId,
      centerId
    );
    commit(mutationTypes.SET_FINALIZED_BILLING_STATUS, data);
  },
};

export default actions;
